/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Icon {
    OfficeBuilding = 'OfficeBuilding',
    UserSingleNeutral = 'UserSingleNeutral',
    UserIdentificationCard = 'UserIdentificationCard',
    Users = 'Users',
    UserInformation = 'UserInformation',
    ModuleThree = 'ModuleThree'
}


export function IconFromJSON(json: any): Icon {
    return IconFromJSONTyped(json, false);
}

export function IconFromJSONTyped(json: any, ignoreDiscriminator: boolean): Icon {
    return json as Icon;
}

export function IconToJSON(value?: Icon | null): any {
    return value as any;
}

